<template>
    <b-modal
        id="modal-otp"
        @hide="$bvModal.hide('modal-otp')"
        hide-header
        hide-footer
        >
        <div class="d-flex flex-column align-items-center block-item mb-4">
            <span class="bell fa fa-bell"></span>
            <div class="fw-800 fz-22">{{ $t('Here is your OTP code') }}</div>
            <div class="text-muted mb-3">{{ $t('a copy of this code has also been sent to your email.') }}</div>
            <div class="text-small text-grey2 fz-14">{{ $t("Expired in") }}</div>
            <div class="fw-500 fz-18 mb-3">{{ expired_at }}</div>
            <div class="otp-display mb-4">{{ otp }}</div>
        </div>
        <div class="btn btn-primary d-block w-100" @click="$bvModal.hide('modal-otp')">{{ $t('Close') }}</div>
    </b-modal>
</template>
<script>
export default {
    data() {
        return {

        }    
    },
    props:['otp','expired_at']
}
</script>

<style scoped>
.bell{
    animation: unset !important;
    width: 3rem;
    height: 3rem;
}
.otp-display {
  font-size: 2.8rem;
  letter-spacing: 1rem;
  font-weight: bold;
  text-align: center;
}
</style>